import { render, staticRenderFns } from "./order.vue?vue&type=template&id=09e2bdd6&scoped=true&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e2bdd6",
  null
  
)

export default component.exports